<template>
    <div>
        <div :class="sticky ? 'sticky-sidebar bg-white w3-animate-left' : ''" :style="sticky ? 'width: 300px;' : ''">
            <ul class="list-group">
                <li class="list-group-item" :class="( sticky || detalhe_marcacao ) ? 'p-2' : ''" v-if="plano_unico">
                    <div class="d-flex justify-content-between">
                        <span class="mr-3">
                            <a href="#" @click.prevent="toggle_all()" class="card-link">
                                <small class="mr-2" v-if="!( removeOnUnSelect || listOnly )">
                                    <i class="fas fa-power-off fa-fw"></i>
                                </small>
                            </a>
                            <small :class="listOnly ? 'lead' : ''">
                                <i class="far fa-credit-card fa-fw mr-1"></i>
                                {{ plano_unico.search }} 
                            </small>
                        </span>
                        <span v-if="link_edit" class="text-nowrap text-right">
                            <span class="badge badge-light mr-2" v-if="!listOnly && false">
                                <span v-if="!removeOnUnSelect">{{ marcados }}/</span>{{ value.length }}
                            </span>
                            
                            <a href="#" @click.prevent="agrupar_procedimentos()" title="Agrupar" class="ml-2" v-if="agrupavel">
                                <i class="fa-solid fa-object-group"></i>
                            </a>

                            <a href="#" @click.prevent="toggle_sticky()" class="ml-2" v-if="!detalhe_marcacao">
                                <i class="fas fa-arrow-right" v-if="sticky"></i>
                                <i class="fas fa-arrow-left" v-else></i>
                            </a>
                        </span>
                    </div>
                    <div v-if="!removeOnUnSelect && link_edit">
                        <div class="progress mt-1">
                            <div class="progress-bar bg-success" role="progressbar" :style="'width: ' + percent(marcados, total) + '%'" ></div>
                            <div class="progress-bar bg-warning" role="progressbar" :style="'width: ' + percent(nao_selecionados, total) + '%'" ></div>
                            <div class="progress-bar bg-danger" role="progressbar" :style="'width: ' + percent(total - marcados - nao_selecionados, total) + '%'" ></div>
                        </div>
                    </div>
                </li>
                <template v-for="(proc, index) in lista_ordenada">
                    <li class="list-group-item" :key="index" v-show="!proc.conjunto" v-if="true"
                        :class="( cores 
                            ? 'list-group-item-' + cores[proc.index] 
                            : ( proc.ch_estado_marcacao == 'B' ? 'list-group-item-danger' : 'list-group-item-light' ) )
                            + ( ( sticky || detalhe_marcacao ) ? ' small p-2' : '' )">

                        <div class="d-flex" :class="( removeOnUnSelect || listOnly ) ? 'flex-column' : ''">
                            <div :class="( removeOnUnSelect || listOnly ) ? 'd-flex' : 'custom-control custom-switch'">
                                
                                <span v-if="removeOnUnSelect || listOnly">
                                    <a class="card-link mr-2" v-if="removeOnUnSelect && !listOnly" href="#" @click.prevent="removehProc (index, proc)">
                                        <i class="fas fa-times fa-fw"></i>
                                    </a>
                                </span>

                                <input 
                                    v-else 
                                    type="checkbox" 
                                    class="custom-control-input" 
                                    :id="'procCustomSwitch' + ( listOnly ? 'lo' : '' ) + index"
                                    v-model="proc.selected" 
                                    @change="switchProc (proc)">
                                
                                <label 
                                    :class="removeOnUnSelect || listOnly ? 'w-100' : 'custom-control-label'" 
                                    :for="'procCustomSwitch' + ( listOnly ? 'lo' : '' ) + index" class="mb-0">
                                    <div :class="listOnly ? 'h4 mb-1' : ''">
                                        <span>
                                            <i class="fas fa-sun mr-2" v-if="proc.ofertado" title="Ofertado pela Clínica"></i>

                                            <i class="fa fa-ban text-danger fa-fw mr-1" aria-hidden="true" v-if="proc.rest_nao_cobre" title="Não Cobre"></i>
                                            <i class="fa fa-exclamation-triangle text-warning fa-fw mr-1" aria-hidden="true" v-else-if="proc.rest_aut_prev" title="Necessita de Autorização Prévia"></i>
                                            
                                            <a href="#" @click.prevent="editar(proc)" v-if="link_edit">
                                                {{ proc.procedimento.search }}
                                            </a>

                                            <span v-else>
                                                {{ proc.procedimento.search }}
                                            </span>

                                            <span v-if="proc.in_quantidade > 1">
                                                <span class="badge badge-light">
                                                    <i class="fa fa-times" aria-hidden="true"></i>
                                                    {{ proc.in_quantidade }}
                                                </span>
                                            </span>

                                            <span v-if="proc.duracao > 0 && listOnly && !proc.slots">
                                                <span class="badge badge-dark mr-1">
                                                    <i class="fa-solid fa-stopwatch mr-1"></i>
                                                    {{ proc.duracao * ( proc.slots ? proc.slots : 1 )  }} min
                                                </span>
                                            </span>

                                            <span v-else-if="proc.tam_slot > 0 && listOnly && proc.slots">
                                                <span class="badge badge-secondary mr-1">
                                                    <i class="fa-solid fa-stopwatch mr-1"></i>
                                                    {{ proc.tam_slot * ( proc.slots ? proc.slots : 1 )  }} min
                                                </span>
                                            </span>

                                            <span v-else-if="proc.duracao_minutos > 5">
                                                <span class="dropdown">
                                                    <button class="btn btn-dark btn-sm dropdown-toggle ml-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        <i class="fa-solid fa-stopwatch mr-1"></i>
                                                        {{ proc.duracao_minutos }} min
                                                    </button>
                                                    <div class="dropdown-menu dropdown-menu-scroll" aria-labelledby="dropdownMenuButton">
                                                        <a class="dropdown-item" href="#" @click.prevent="proc.duracao_minutos = tempo" v-for="(tempo, itx) in lista_tempos(proc.duracao_minutos, proc)" :key="itx">{{ tempo }} min</a>
                                                    </div>
                                                </span>
                                            </span>

                                            <!-- Procedimentos Adicionais -->
                                            <template v-if="( proc.outros_procedimentos && proc.outros_procedimentos.length ) || proc.slots || proc.duracao">
                                                <span class="badge badge-primary" v-if="proc.outros_procedimentos && proc.outros_procedimentos.length">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                    {{ proc.outros_procedimentos.length }}
                                                </span>
                                            </template>

                                            <template v-if="true">

                                                <span v-if="listOnly">
                                                    <div class="btn-group ml-1">
                                                        <button class="btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                            :class="proc.slots > 1 ? 'btn-primary' : 'btn-secondary'">
                                                            <template v-if="!proc.slots">
                                                                Ocupar
                                                            </template>
                                                            <template v-else>
                                                                {{ proc.slots ? proc.slots : 1 }}
                                                                {{ proc.slots > 1 ? 'horários' : 'horário' }}
                                                            </template>
                                                        </button>
                                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                            <a class="dropdown-item" href="#" @click="proc.slots = ''" :class="!proc.slots ? 'active' : ''">
                                                                Ocupação Padrão
                                                            </a>
                                                            <a class="dropdown-item" href="#" @click="proc.slots = 1" :class="proc.slots == 1 ? 'active' : ''">
                                                                Ocupar 1 horário da agenda
                                                                <template v-if="proc.tam_slot">
                                                                    | {{ proc.tam_slot }} min
                                                                </template>
                                                            </a>
                                                            <a class="dropdown-item" href="#" v-for="idx in 15" :key="idx" teste="proc.outros_procedimentos.length"
                                                                @click="proc.slots = idx + 1" :class="proc.slots == idx + 1 ? 'active' : ''">
                                                                Ocupar {{ idx + 1 }} horários da agenda

                                                                <template v-if="proc.tam_slot">
                                                                    | {{ proc.tam_slot * ( idx + 1 ) }} min
                                                                </template>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </span>

                                            </template>

                                            <template v-if="listOnly">
                                                <div class="btn-group ml-2" v-if="proc.procedimento.js_complementos && proc.procedimento.js_complementos.length">
                                                    <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        {{ proc.st_regiao ? proc.st_regiao  : ( proc.procedimento.cfm ? 'Relação...' : 'Região...' ) }}
                                                    </button>
                                                    <div class="dropdown-menu dropdown-menu-scroll" aria-labelledby="dropdownMenuButton">
                                                        <a class="dropdown-item" 
                                                            href="#" v-for="(regiao, irx) in proc.procedimento.js_complementos" 
                                                            :key="irx"
                                                            @click.prevent="regiao_add(proc, regiao)" :class="regiao_tem(proc, regiao) ? 'active' : ''">
                                                            {{ regiao }}
                                                        </a>
                                                    </div>
                                                </div>

                                                <span class="dropdown" v-if="resumo_marcacao && proc.procedimento && proc.procedimento.id_classe_procedimento == 17">
                                                    <button class="btn btn-sm btn-primary ml-2 dropdown-toggle" type="button" id="dropdownMenuButtonClone" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                                    </button>
                                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonClone">
                                                        <a class="dropdown-item" href="#" @click="clonar_procedimento(proc, true)">Agendar outro para o <b>MESMO</b> profissional</a>
                                                        <a class="dropdown-item" href="#" @click="clonar_procedimento(proc, false)">Agendar outro para <b>QUALQUER</b> profissional</a>
                                                    </div>
                                                </span>

                                                <button type="button" class="btn btn-sm btn-primary ml-2" title="Marcar outro procedimento igual."
                                                    v-if="false && resumo_marcacao && proc.procedimento && proc.procedimento.id_classe_procedimento == 17"
                                                    @click="clonar_procedimento(proc)">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                </button>

                                            </template>
                                            <template v-else-if="proc.st_regiao">
                                                <span class="badge badge-secondary ml-2">{{ proc.st_regiao }}</span>
                                            </template>

                                            <template v-if="proc.procedimento_equipamentos && proc.procedimento_equipamentos.length">
                                                <span class="badge badge-secondary ml-2" v-for="(pe, ipx) in proc.procedimento_equipamentos" :key="ipx">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                    <template v-if="pe.st_tipo == 'E' || pe.equipamento">
                                                        {{ pe.equipamento ? pe.equipamento.st_sigla : pe.id_equipamento }}
                                                    </template>
                                                    <template v-else-if="pe.st_tipo == 'C'">
                                                        {{ pe.st_classe }}
                                                    </template>
                                                </span>
                                            </template>
                                        </span>
                                        
                                        <div v-if="proc.js_outros_procedimentos && proc.js_outros_procedimentos.length">
                                            <div class="small text-muted"  v-for="(outro, iox) in proc.js_outros_procedimentos" :key="iox">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                                <span>{{ outro.search }}</span>
                                            </div>
                                        </div>
                                        <i class="fas fa-registered text-warning" aria-hidden="true" v-if="proc.tipo_consulta == 'R'"></i>
                                        <span class="badge badge-pill badge-warning" v-else-if="proc.tipo_consulta">
                                            {{ proc.tipo_consulta }}
                                        </span>
                                        <span class="badge badge-light" v-if="proc.qtde">
                                            {{ proc.qtde }}
                                        </span>
                                        <div class="badge badge-danger" v-if="proc.ch_estado_marcacao == 'B'">
                                            BLOQUEADO
                                        </div>
                                    </div>
                                    <div :class="listOnly ? 'd-flex justify-content-between' : ''">
                                        <div>
                                            <span v-if="proc.plano && !plano_unico && proc.plano.search" class="mr-3">
                                                <small :class="listOnly ? 'lead' : ''">
                                                    <i class="far fa-credit-card fa-fw mr-1"></i>
                                                    {{ proc.plano.search }} 
                                                </small>
                                            </span>
                                            <span v-if="proc.medico" class="mr-2">
                                                <a href="#" @click.prevent="abrir_info_medico(proc.medico)" class="card-link text-reset" v-if="!listOnly">
                                                    <small>
                                                        <i class="fas fa-user-md fa-fw mr-1"></i>
                                                        {{ proc.medico.st_nome_exibicao }} 
                                                    </small>
                                                </a>
                                                <small class="lead" v-else>
                                                    <i class="fas fa-user-md fa-fw mr-1"></i>
                                                    {{ proc.medico.st_nome_exibicao }} 
                                                </small>
                                            </span>
                                            <span v-if="proc.unidade" class="mr-2">
                                                <small :class="listOnly ? 'lead' : ''">
                                                    <i class="far fa-building fa-fw mr-1"></i>
                                                    {{ proc.unidade }} 
                                                    <small class="text-muted" v-if="listOnly && proc.local_nome"> / {{ proc.local_nome }}</small>
                                                </small>
                                            </span>
                                            <span v-else-if="proc.unidade_operacao" class="mr-2">
                                                <small :class="listOnly ? 'lead' : ''">
                                                    <i class="far fa-building fa-fw mr-1"></i>
                                                    {{ proc.unidade_operacao.st_sigla }} 
                                                </small>
                                            </span>
                                        </div>

                                        <pre v-if="false">{{ proc.medico }}</pre>

                                        <div class="small" v-if="proc.regiao_cd">
                                            <i class="fa-solid fa-location-dot fa-fw mr-1"></i>{{ proc.regiao_cd.search }}
                                        </div>

                                        <!-- Exibição da Data -->
                                        <div v-if="proc.data" :class="listOnly ? 'lead' : ''">
                                            <small>
                                                <i class="far fa-calendar-alt mr-1"></i>
                                                {{ getFormatDate (proc.data, 'DD') + '/' + getFormatDate (proc.data, 'MMM') }} 
                                                <span class="badge badge-light mr-2">{{ getFormatDate (proc.data, 'ddd') }}</span>
                                            </small>
                                            
                                            <small class="mx-2">
                                                <i class="fas fa-clock mr-1"></i>
                                                
                                                <span v-if="proc.hg || proc.hora && hora_final(proc)">
                                                    {{ proc.hg ? proc.hg : proc.hora }}-{{ hora_final(proc) }}
                                                </span>
                                                <span v-else>
                                                    {{ proc.hg ? proc.hg : proc.hora }}
                                                </span>
                                            </small>
                                        </div>
                                        <div v-if="proc.id_marcacao && proc.dt_inicio" :class="listOnly ? 'lead' : ''">
                                            <small class="mr-1">
                                                <i class="far fa-calendar-alt mr-1"></i>
                                                {{ $util.getFormatDate (proc.dt_inicio) }} {{ proc.dt_inicio.substr(11,5) }} 
                                            </small>
                                        </div>
                                    </div>
                                    <div v-if="proc.medico && listOnly && proc.medico.instrucao">
                                        <blockquote class="blockquote mb-0" v-if="listOnly && proc.medico.instrucao">
                                            <footer class="blockquote-footer text-nowrap text-truncate" :id="'instr-proc-med-' + index"
                                                @mouseover="hover('instr-proc-med-' + index, true)" 
                                                @mouseleave="hover('instr-proc-med-' + index, false)">
                                                {{ proc.medico.instrucao }}
                                            </footer>
                                        </blockquote>
                                    </div>
                                    <div v-if="listOnly && proc.proc_instrucao">
                                        <blockquote class="blockquote mb-0">
                                            <footer class="blockquote-footer text-nowrap text-truncate" :id="'instr-proc-' + index"
                                                @mouseover="hover('instr-proc-' + index, true)" 
                                                @mouseleave="hover('instr-proc-' + index, false)">
                                                {{ proc.proc_instrucao }}
                                            </footer>
                                        </blockquote>
                                    </div>

                                    <div v-if="proc.id_solicitacao_autorizacao" class="small text-muted">
                                        <i class="fa-solid fa-stamp mr-2"></i>
                                        {{ ( proc.id_solicitacao_autorizacao == -1 ) ? 'A ser criada' : proc.id_solicitacao_autorizacao }}
                                    </div>
                                </label>
                                
                            </div>
                        </div>

                        <div v-if="proc.subespecialidades">
                            {{ proc.subespecialidades.join(', ') }}
                        </div>

                    </li>
                </template>
            </ul>

            <div v-if="exibir_ordenacao" class="d-flex justify-content-between">
                <div class="text-danger">
                    {{ conflito_horarios }}
                </div>
                <div>
                    <a href="#" class="card-link mr-2" @click.prevent="ordem_hora = !ordem_hora">
                        <span v-if="!ordem_hora" title="Ordenar por data/hora da marcação.">
                            <i class="fas fa-long-arrow-alt-down"></i>
                            <i class="far fa-clock"></i>
                        </span>
                        <span v-else title="Cancelar ordenação por data/hora da marcação.">
                            <i class="fas fa-long-arrow-alt-down"></i>
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </span>
                    </a>
                </div>
            </div>

            <slot></slot>
        </div>

        <!-- Modal -->
        <div class="modal fade" :id="'medicoInfoModal' + modal_dif" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="info_medico">
                    <div class="modal-header">
                        <h5 class="modal-title">Profissional: {{ info_medico.st_nome_exibicao }}</h5>
                            <button type="button" class="close" @click="fechar('medicoInfoModal' + modal_dif)" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="info_medico.st_assinatura" style="white-space: pre-wrap;">{{ info_medico.st_assinatura }}</div>
                        <div v-else>
                            <div class="lead">{{ info_medico.st_nome_exibicao }}</div>
                            <div>{{ info_medico.numero_formatado }}</div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar('medicoInfoModal' + modal_dif)">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" :id="'qtdeModal' + modal_dif" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="index_qtde">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Quantidade</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="index_qtde == 9 && value[index_qtde]">
                        <p>{{ index_qtde }}</p>
                        <p>{{ value[index_qtde].qtde }}</p>
                    </div>
                    <div class="modal-body" v-if="index_qtde >= 0 && value[index_qtde]">
                        <div class="form-group">
                            <input type="number" min="1" max="8" v-model="value[index_qtde].qtde" class="form form-control">
                        </div>
                        <div class="form-group">
                            <label for="formControlRange">Example Range input</label>
                            <input type="range" class="form-control-range" id="formControlRange" v-model="value[index_qtde].qtde"
                                min="1" max="8">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="teste ()">Próximo</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Agrupar Marcação -->
        <div class="modal fade" :id="'agrupaProcModal' + modal_key" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="grupo_selecao">
                    <div class="modal-header">
                        <h5 class="modal-title">Agrupar</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info d-flex justify-content-between">
                            <div>
                                <a href="#" @click.prevent="confirmar_agrupamento()" class="card-link" v-if="grupo_qt_selec > 0">Agrupar</a>
                            </div>
                            <div>
                                {{ grupo_qt_selec }}/{{ lista_ordenada.length }}
                            </div>
                        </div>

                        <div class="progress my-1">
                            <div class="indeterminate" v-if="$store.state.loading"></div>
                            <div class="determinate" v-else></div>
                        </div>

                        <table class="table table-sm table-hover small mb-0">
                            <thead>
                                <tr>
                                    <th>
                                        <a href="#" @click.prevent="agrupar_selecionar_tudo()">
                                            <i class="fas fa-square-full"></i>
                                        </a>
                                    </th>
                                    <th>Procedimento</th>
                                    <th>Especialidade</th>
                                    <th>Profissional</th>
                                    <th>Und</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(proc, index) in lista_ordenada" :key="index" :class="grupo_selecao[index] ? 'table-primary' : ''">
                                    <td>
                                        <input type="checkbox" v-model="grupo_selecao[index]">
                                    </td>
                                    <td>
                                        {{ proc.procedimento.search }}

                                        <span class="badge badge-primary" v-if="proc.outros_procedimentos && proc.outros_procedimentos.length">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                            {{ proc.outros_procedimentos.length }}
                                        </span>
                                    </td>
                                    <td>
                                        <a href="#" @click.prevent="selecionar_agrupamento(proc, 'procedimento.id_especialidade')" class="card-link">
                                            {{ proc.procedimento.especialidade ? proc.procedimento.especialidade.search : '' }}
                                        </a>
                                    </td>
                                    <td>
                                        <a href="#" @click.prevent="selecionar_agrupamento(proc, 'medico.id_pessoa')" class="card-link">
                                            {{ proc.medico ? proc.medico.search : '' }}
                                        </a>
                                    </td>
                                    <td>
                                        {{ proc.unidade_operacao ? proc.unidade_operacao.st_sigla : '' }} 
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <pre v-if="false">{{ lista_ordenada }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import * as moment from 'moment';
import $ from 'jquery';

export default {
    data () { 
        return { 
            index_qtde: null,
            item: null,
            info_medico: null, 
            ordem_hora: false,
            modal_key: "", 
            grupo_selecao: null, 
        }
    },

    watch: { 
        value: function (newValue) { 
            this.$emit('input', newValue);
        }
    },

    props: [ 'value', 'cores', 'removeOnUnSelect', 'listOnly', 'link_edit', 'sticky', 'detalhe_marcacao', 'ordem', 'resumo_marcacao', 'agrupavel'],

    computed: { 
        grupo_qt_selec: function () { 
            if ( !this.grupo_selecao )
                return 0; 

            return this.grupo_selecao.filter(item => item).length;
        },

        modal_dif: function () { 
            return ( this.listOnly ? 'LO' : 'NLO' )
                + ( this.link_edit ? '-LE' : '-NLE' )
                + ( this.sticky ? '-ST' : '-NST' )
                + ( this.detalhe_marcacao ? '-DM' : '-NDM' );
        },

        marcados: function () { 
            return this.value.filter(item => item && ( item.hora || item.conjunto ) ).length;
        },

        nao_selecionados: function () { 
            return this.value.filter(item => !item.hora && !item.conjunto && !item.selected).length;
        },

        total: function () { 
            return this.value.length;
        },

        plano_unico: function () { 
            if ( !this.value || this.value.length == 1 )
                return null;

            const lista = _.map(
                _.uniqBy(this.value, 'plano.id_plano'),
                item => item.plano
            );

            return lista.length == 1 ? _.first(lista) : null;
        },

        exibir_ordenacao: function () { 
            return this.value.length > 1 && 
                ( this.ordem || ( this.sticky && !(this.removeOnUnSelect || this.listOnly) ) );
        },

        lista_ordenada: function () { 
            if ( this.exibir_ordenacao && this.ordem_hora ) { 
                return _.orderBy(
                    this.value, 
                    item => item.data + ' ' + item.hora
                );
            }

            return this.value;
        },

        conflito_horarios: function () { 
            if ( !this.value || !this.value.length || this.value.length <= 1 ) 
                return false;

            const horarios = this.value.filter(item => item.hora).map(item => { 
                return { 
                    indice: item.index, 
                    inicio: moment(item.data + ' ' + item.hora, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm'), 
                    fim: moment(item.data + ' ' + this.hora_final(item), 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm'), 
                    procedimento: item.procedimento,
                }
            });

            let conflito = null;

            for ( let i = 0; i < horarios.length; i++ ) { 
                for ( let j = 0; j < horarios.length; j++ ) { 
                    if ( i != j ) { 
                        if ( horarios[i].inicio < horarios[j].fim && horarios[i].fim > horarios[j].inicio ) { 
                            conflito = horarios[i].procedimento.st_procedimento + ' conflita horário com ' + horarios[j].procedimento.st_procedimento;
                            break;
                        }
                    }
                }

                if ( conflito ) { 
                    break;
                }
            }

            return conflito;
        },
    },

    methods: { 
        selecionar_agrupamento (proc, campo) { 

            this.$store.commit("loading", true);

            let selec = this.lista_ordenada.findIndex((item, idx) => _.get(this.grupo_selecao, idx) 
                && ( _.get(item, campo) === _.get(proc, campo) ) );

            this.lista_ordenada.forEach((item, index) => { 
                if ( _.get(item, campo) === _.get(proc, campo) ) { 
                    this.$set(this.grupo_selecao, index, !( selec >= 0 ));
                }
            });

            this.$store.commit("loading", false);
            
        },

        agrupar_selecionar_tudo () { 
            const selec = this.grupo_selecao.findIndex(item => !item) >= 0 ? true : false;

            this.grupo_selecao = this.grupo_selecao.map(() => selec);
        },

        confirmar_agrupamento () { 

            let primeiro_obj = this.lista_ordenada.find((item, index) => this.grupo_selecao[index]);
            let primeiro_idx = this.lista_ordenada.findIndex((item, index) => this.grupo_selecao[index]);

            if ( !primeiro_obj ) { 
                return;
            }

            if ( !primeiro_obj.outros_procedimentos ) { 
                primeiro_obj.outros_procedimentos = []; 
            }

            this.lista_ordenada.forEach((item, index) => { 
                if ( this.grupo_selecao[index] && index != primeiro_idx ) { 
                    let novo = { 
                        in_quantidade: item.in_quantidade > 1 ? item.in_quantidade : 1,
                        id_procedimento: item.procedimento.id_procedimento,
                        search: item.procedimento.search, 
                        js_complementos: [],
                        st_regiao: "", 
                    };

                    /*
                    if ( item.fl_block_valor ) { 
                        ret.fl_block_valor = true;
                    }

                    if ( item.dc_valor_procedimento || item.dc_valor_procedimento === 0 ) { 
                        ret.dc_valor_procedimento = item.dc_valor_procedimento;
                    }
                    */

                    primeiro_obj.outros_procedimentos.push(novo);

                    item.remover = true; 
                
                }
            });

            /*
            this.value.reduceRight((total, item, idx) => { 
                if ( item.remover ) { 
                    this.value.splice(idx, 1);
                }
            });
            */

            this.grupo_selecao = this.lista_ordenada.map(() => false);

            this.$emit('input', this.value.filter(item => !item.remover));

            this.$forceUpdate(); 

        }, 

        agrupar_procedimentos () { 
            this.grupo_selecao = this.lista_ordenada.map(() => false);
            $('#agrupaProcModal' + this.modal_key).modal('show');
        },

        hora_final (item) { 
            if ( !item.hora ) { 
                return; 
            }

            let tempo; 

            if ( item.slots && item.tam_slot ) { 
                tempo = item.slots * item.tam_slot;
            } else if ( !item.slots && item.duracao ) { 
                tempo = item.duracao;
            } else if ( !item.slots && item.tam_slot ) { 
                tempo = item.tam_slot;
            }

            let base = item.hg ? item.hg : item.hora; 
            let final = moment(base, 'HH:mm').add(tempo, 'minutes').format("HH:mm");
            
            return final;
        },

        lista_tempos(duracao, proc = null) { 
            let fator = ( proc && proc.id_marcacao ) ? 2 : 1;
            let lista = [];

            for ( let i = 10; i <= ( duracao * fator ); i += 5 ) { 
                lista.push(i);
            }

            return lista;
        },

        clonar_procedimento (proc, mesmo_profissional = true) { 
            let item = _.cloneDeep(proc);

            if ( !mesmo_profissional ) { 
                item.medico = null;
            }

            this.$emit('clonar', item);
        },

        regiao_tem (proc, texto) { 
            let items = proc.st_regiao ? proc.st_regiao.split(', ') : [];
            return items.find(item => item == texto) ? true : false; 
        },

        regiao_add (proc, texto) { 
            let items = proc.st_regiao ? proc.st_regiao.split(', ') : [];

            let index = items.findIndex(item => item == texto);

            if ( index >= 0 ) { 
                items.splice(index, 1);
            } else { 
                items.push(texto);
            }
                
            proc.st_regiao = items.join(', ');
        },

        percent (parte, total) { 
            return total ? Math.round( ( parte / total ) * 100 ) : 0;
        },

        toggle_all () { 
            const selec = this.value.find(item => !item.selected && !item.conjunto) ? true : false;

            this.value.filter(item => !item.conjunto)
                .forEach(item => { 
                    item.selected = selec;
                });

            this.$nextTick(() => { 
                this.$emit('selecionar');
                this.$emit('refresh_detalhes');
            });
        },

        toggle_sticky () { 
            this.$emit('sticky', this.sticky);
        },

        editar(proc) { 
            if ( this.removeOnUnSelect || this.listOnly ) { 
                this.$emit('editar', proc);
            } else { 
                if( !proc.selected || ( this.value.filter(item => item.selected && !item.conjunto).length > 1 ) ) { 

                    this.value.filter(item => !item.conjunto)
                        .forEach(item => { 
                            item.selected = false;
                        });

                    proc.selected = true;

                    this.$nextTick(() => { 
                        this.$emit('marcar_medicos', proc);
                        this.$emit('refresh_detalhes');
                    });
                    
                } else { 

                    this.$emit('editar', proc);

                }
            }
        },

        fechar(modal) { 
            $('#' + modal).modal('hide');        
        },

        abrir_info_medico(medico) { 
            this.info_medico = medico;

            this.$nextTick(() => { 
                $('#medicoInfoModal' + this.modal_dif).modal('show');
            });
        },

        hover(id, inIt) { 
            if ( inIt ) { 
                $('#' + id).removeClass('text-nowrap');
                $('#' + id).removeClass('text-truncate');
            } else { 
                $('#' + id).addClass('text-nowrap');
                $('#' + id).addClass('text-truncate');
            }
        },

        getFormatDate (date, format) { 
            return moment(date, 'YYYY-MM-DD').format(format);
        },

        switchProc (proc) { 
            if ( this.listOnly ) { 
                return;
            }

            this.$emit('selecionar', proc.selected);
        },

        removehProc (index, proc) { 
            proc.selected = false;
            this.$emit('editar', proc);
            
            this.value.splice(index, 1);

            this.$nextTick(() => {
                this.$forceUpdate ();
                this.$emit('removido');
            });
        },

        replicar (index) { 
            this.index_qtde = index; 
            $('#qtdeModal' + this.modal_dif).modal('show');
        },

        teste () { 
            $('#qtdeModal' + this.modal_dif).modal('hide');
            this.$forceUpdate ();
        } 

    },

    mounted() { 
        this.modal_key = this.$util.uuidv4(); 
    }
}
</script>

<style scoped>
.sticky-sidebar {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 160px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  left: 0;
  background-color: #111; /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 116px;
}
</style>